exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messageMode{position:fixed;left:0;top:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:99}.messageMode .saveMessage{position:absolute;top:6.2rem;left:10%;width:80%;height:4.026667rem;text-align:center;background-color:#fff;color:#333;z-index:100}.messageMode .saveMessage h5{font-size:.4rem;margin:.48rem 0;font-weight:700}.messageMode .saveMessage p{font-size:.346667rem}.messageMode .saveMessage span{display:block;margin:.666667rem auto .48rem;width:8rem;height:1.85rem;border-radius:.106667rem;font-size:.4rem;line-height:1.85rem;background-color:#fdbf03;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bf3f454","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MessageConfirm.vue
// module id = 445
// module chunks = 0